import { Popover, Tag } from 'antd';
import { pricingSimulatorDataContext } from 'contexts/PricingSimulatorContext';
import { useContext, useState } from 'react';
import { LoadingOutlined, CheckCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { ConfigKeys } from 'utils/Enums';
import { useEffect } from 'react';

const ScenarioTag = () => {
    const { selectedScenarioInfo } = useContext(pricingSimulatorDataContext);
    const { appConfig } = useContext(UserContext);
    const pricingSimulatorConfig = getConfig(ConfigKeys.PRICING_SIMULATOR, appConfig);
    const hideBulkUploadButton = !pricingSimulatorConfig?.enableBulkUpload;
    const [open, setOpen] = useState(false);
    const [messageIndex, setMessageIndex] = useState(0);

    const uploadInfo = selectedScenarioInfo?.bulkUploadInfo;

    const progressMessages = [
        'Bulk update is in progress',
        'Processing data',
        'Processing Cascading logic',
        'Finalizing bulk edit',
    ];

    useEffect(() => {
        if (uploadInfo?.status === 'IN_PROGRESS') {
            const interval = setInterval(() => {
                setMessageIndex((prev) => {
                    if (prev < progressMessages.length - 1) {
                        return prev + 1;
                    } else {
                        clearInterval(interval);
                        return prev;
                    }
                });
            }, 60000); // 1 minute

            return () => clearInterval(interval);
        } else {
            setMessageIndex(0); // Reset when status changes
        }
    }, [uploadInfo?.status]);

    if (hideBulkUploadButton) return null;

    const content = (
        <div className="max-h-[300px] w-[300px] overflow-y-auto bg-backgroundGreyAlt p-2 rounded-xl pr-2">
            {uploadInfo?.errorObject?.errors?.map((group: any, idx: number) => (
                <div
                    key={idx}
                    className={`mb-2 pb-2 border-borderGreyAl1 ${
                        idx < uploadInfo?.errorObject?.errors.length - 1 ? 'border-b ' : ''
                    }`}
                >
                    <div className="text-redAlt">{group.title}</div>
                    {group.description.map((msg: string, i: number) => (
                        <div key={i} className="opacity-70 pb-1 mb-1">
                            {msg}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );

    switch (uploadInfo?.status) {
        case 'IN_PROGRESS':
            return (
                <Tag
                    icon={<LoadingOutlined />}
                    color="blue"
                    style={{ display: 'flex', alignItems: 'center', padding: '2px 8px', borderRadius: '5px' }}
                >
                    {progressMessages[messageIndex]}
                </Tag>
            );
        case 'SUCCESS':
            return (
                <Tag
                    icon={<CheckCircleOutlined />}
                    color="green"
                    style={{ display: 'flex', alignItems: 'center', padding: '2px 8px', borderRadius: '5px' }}
                >
                    Bulk Editing Complete
                </Tag>
            );
        case 'ERROR':
            return (
                <Popover
                    content={content}
                    title={false}
                    trigger="click"
                    open={open}
                    onOpenChange={(visible) => setOpen(visible)}
                    placement="bottomLeft"
                >
                    <Tag
                        icon={<InfoCircleOutlined />}
                        color="red"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            padding: '2px 8px',
                            borderRadius: '5px',
                        }}
                    >
                        Bulk Edit failed
                    </Tag>
                </Popover>
            );
        default:
            return null;
    }
};

export default ScenarioTag;
